import { useState, useEffect, useRef } from "react";
import axios from "axios";
import baseURL from "./../../../../../Url/NodeBaseURL";
import { useLocation } from "react-router-dom";
import Webcam from "react-webcam";

const useProductHandlers = () => {
  const [products, setProducts] = useState([]);
  const [data, setData] = useState([]);
  const [isQtyEditable, setIsQtyEditable] = useState(false);
  const location = useLocation();
  
  // Local stock tracking: barcode -> { rem_pcs, rem_gross_weight }
  // Don't persist in localStorage - clear on page refresh
  const [localStock, setLocalStock] = useState({});

  // Access the passed state (default to an empty object if undefined)
  const {
    invoice_number = "",
    estimate_number = "", //marre@
    mobile = "",
  } = location.state || {};

  const [rates, setRates] = useState({
    rate_24crt: "",
    rate_22crt: "",
    rate_18crt: "",
    rate_16crt: "",
  });
//
  // const [formData, setFormData] = useState({
  //   id: '',
  //   customer_id: "value001",
  //   mobile: mobile,
  //   account_name: "",
  //   email: "",
  //   address1: "",
  //   address2: "",
  //   city: "",
  //   pincode: "",
  //   state: "",
  //   state_code: "",
  //   aadhar_card: "",
  //   gst_in: "",
  //   pan_card: "",
  //   terms: "Cash",
  //   date: "",
  //   invoice_number: invoice_number,
  //   code: "",
  //   product_id: "",
  //   metal: "",
  //   product_name: "",
  //   metal_type: "",
  //   design_name: "",
  //   purity: "",
  //   selling_purity: "",
  //   printing_purity: "",
  //   pricing: "By Weight",
  //   category: "",
  //   sub_category: "",
  //   gross_weight: "",
  //   stone_weight: "",
  //   weight_bw: "",
  //   stone_price: "",
  //   va_on: "Gross Weight",
  //   va_percent: "",
  //   wastage_weight: "",
  //   total_weight_av: "",
  //   mc_on: "MC %",
  //   disscount_percentage: "",
  //   disscount: "",
  //   mc_per_gram: "",
  //   making_charges: "",
  //   rate: "",
  //   pieace_cost: "",
  //   mrp_price: "",
  //   rate_amt: "",
  //   tax_percent: "03% GST",
  //   tax_amt: "",
  //   hm_charges: "60.00",
  //   total_price: "",
  //   transaction_status: "Sales",
  //   qty: "1",
  //   opentag_id: "",
  //   product_image: null,
  //   imagePreview: null,
  //   remarks: "",
  //   sale_status: "Delivered",
  //   piece_taxable_amt:"",
  //   festival_discount :"",
  //   custom_purity:"",
  // });

  const getFreshFormData = (mobile) => ({
    id: "",
    customer_id: "",
    mobile: mobile,
    account_name: "",
    email: "",
    address1: "",
    address2: "",
    city: "",
    pincode: "",
    state: "",
    state_code: "",
    aadhar_card: "",
    gst_in: "",
    pan_card: "",
    terms: "Cash",
    date: "",
    invoice_number: invoice_number,
    estimate_number: estimate_number, //marre@
    code: "",
    product_id: "",
    metal: "",
    product_name: "",
    metal_type: "",
    design_name: "",
    purity: "",
    selling_purity: "",
    printing_purity: "",
    pricing: "By Weight",
    pricingOpt:"Net Weight",
    category: "",
    sub_category: "",
    gross_weight: "",
    stone_weight: "",
    weight_bw: "",
    stone_price: "",
    va_on: "Gross Weight",
    va_percent: "",
    wastage_weight: "",
    total_weight_av: "",
    mc_on: "MC %",
    disscount_percentage: "",
    disscount: "",
    mc_per_gram: "",
    making_charges: "",
    rate: "",
    // rate_24k: "",
    pieace_cost: "",
    mrp_price: "",
    rate_amt: "",
    tax_percent: "03% GST",
    tax_amt: "",
    hm_charges: "60.00",
    total_price: "",
    transaction_status: "Sales",
    qty: "1",
    opentag_id: "",
    product_image: null,
    imagePreview: null,
    remarks: "",
    sale_status: "Delivered",
    estimate_status: "Not Delivered",
    piece_taxable_amt: "",
    festival_discount: "",
    custom_purity: "",
    manual_price_update: false,
    order_number: "",
    receipts_amt: "",
    bal_after_receipts: "",
  tag_balance_pcs: "",
  tag_balance_weight: "",
  });

  const [formData, setFormData] = useState(() => {
    const savedData = localStorage.getItem(`saleFormData`);
    if (savedData) {
      return JSON.parse(savedData);
    }
    return getFreshFormData(mobile);
  });

  useEffect(() => {
    localStorage.setItem(`saleFormData`, JSON.stringify(formData));
  }, [formData]);

  const [uniqueProducts, setUniqueProducts] = useState([]);
  const [metalTypes, setMetalTypes] = useState([]);
  const [purity, setPurity] = useState([]);
  const [filteredMetalTypes, setFilteredMetalTypes] = useState([]);
  const [filteredDesignOptions, setFilteredDesignOptions] = useState([]);
  const [filteredPurityOptions, setFilteredPurityOptions] = useState([]);
  const [isBarcodeSelected, setIsBarcodeSelected] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [metaltypeOptions, setMetaltypeOptions] = useState([]);
  const [purityOptions, setpurityOptions] = useState([]);
  const [designOptions, setDesignOptions] = useState([]);
  const [image, setImage] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [showWebcam, setShowWebcam] = useState(false);
  const webcamRef = useRef(null);
  const fileInputRef = useRef(null);

  // useEffect(() => {
  //   let currentRate = "";

  //   const isGoldLikeMetal = ["gold", "diamond", "others"].includes(formData.metal_type?.toLowerCase());

  //   if (isGoldLikeMetal) {
  //     if (!formData.purity) {
  //       currentRate = rates.rate_22crt; // Default to 22-carat rate if purity is empty
  //     } else if (formData.purity.includes("24")) {
  //       currentRate = rates.rate_24crt;
  //     } else if (formData.purity.includes("22")) {
  //       currentRate = rates.rate_22crt;
  //     } else if (formData.purity.includes("18")) {
  //       currentRate = rates.rate_18crt;
  //     } else if (formData.purity.includes("16")) {
  //       currentRate = rates.rate_16crt;
  //     } else {
  //       currentRate = rates.rate_22crt; // Default to 22-carat rate if no match
  //     }
  //   } else if (formData.metal_type?.toLowerCase() === "silver") {
  //     currentRate = rates.silver_rate;
  //   }

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     rate: currentRate,
  //   }));
  // }, [formData.purity, formData.metal_type, rates]);

  useEffect(() => {
    const fetchCurrentRates = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/current-rates`);
        const newRates = {
          rate_24crt: response.data.rate_24crt || "",
          rate_22crt: response.data.rate_22crt || "",
          rate_18crt: response.data.rate_18crt || "",
          rate_16crt: response.data.rate_16crt || "",
          silver_rate: response.data.silver_rate || "",
        };
        setRates(newRates);

        // Update form data based on metal type
        const metalType = formData.metal_type?.toLowerCase();

        setFormData((prev) => ({
          ...prev,
          rate_24k:
            metalType === "silver" ? newRates.silver_rate : newRates.rate_24crt,
        }));
      } catch (error) {
        console.error("Error fetching current rates:", error);
      }
    };

    fetchCurrentRates();
  }, [formData.metal_type]);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${baseURL}/get/products`);
      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }
      const result = await response.json();
      setProducts(result);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchTags = async () => {
    try {
      const response = await fetch(`${baseURL}/get/opening-tags-entry`);
      if (!response.ok) {
        throw new Error("Failed to fetch tags");
      }
      const result = await response.json();
      setData(result.result);
      
      // Initialize local stock from fetched tag data
      setLocalStock((prev) => {
        const initialStock = {};
        if (result.result && Array.isArray(result.result)) {
          result.result.forEach((tag) => {
            const barcode = String(tag.PCode_BarCode || "");
            if (barcode) {
              const remPcs = tag.rem_pcs !== undefined && tag.rem_pcs !== null 
                ? tag.rem_pcs 
                : tag.pcs;
              const remWeight = tag.rem_gross_weight ?? tag.balance_weight ?? tag.remaining_weight ?? "";
              
              // Only initialize if not already in local stock (preserve user's local changes)
              if (!prev[barcode]) {
                initialStock[barcode] = {
                  rem_pcs: remPcs !== undefined && remPcs !== null ? remPcs : "",
                  rem_gross_weight: remWeight,
                };
              }
            }
          });
        }
        
        // Merge with existing local stock (preserve decrements)
        const merged = { ...prev, ...initialStock };
        // Don't persist to localStorage - clear on refresh
        return merged;
      });
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchTags();
    // Clear any persisted local stock on mount (page refresh)
    localStorage.removeItem('localStockTracking');
  }, []);

  // Add this state to track manual changes
  const [isManualTotalPriceChange, setIsManualTotalPriceChange] =
    useState(false);
  const [isTotalPriceCleared, setIsTotalPriceCleared] = useState(false);

  const getRateByPurity = (purityValue, rates, formData) => {
    if (purityValue === 99.9 && rates.rate_24crt) {
      return parseFloat(rates.rate_24crt).toFixed(2);
    }
    if (purityValue === 91.6 && rates.rate_22crt) {
      return parseFloat(rates.rate_22crt).toFixed(2);
    }
    if (purityValue === 75 && rates.rate_18crt) {
      return parseFloat(rates.rate_18crt).toFixed(2);
    }

    if (formData.rate_24k) {
      const baseRate = parseFloat(formData.rate_24k);
      return ((purityValue / 100) * baseRate).toFixed(2);
    }

    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "total_price") {
      setIsManualTotalPriceChange(true);
    }
    
    // Handle qty change for "By Running Tag" pricing - recalculate weights
    if (name === "qty" && formData.pricing === "By Running Tag" && formData.tag_pcs && formData.tag_pcs > 1) {
      const newQty = parseFloat(value) || 1;
      const updatedFormData = {
        ...formData,
        qty: value,
        gross_weight: formData.tag_gross_weight_per_piece 
          ? (formData.tag_gross_weight_per_piece * newQty).toFixed(3) 
          : formData.gross_weight,
        stone_weight: formData.tag_stone_weight_per_piece 
          ? (formData.tag_stone_weight_per_piece * newQty).toFixed(3) 
          : formData.stone_weight,
        weight_bw: formData.tag_weight_bw_per_piece 
          ? (formData.tag_weight_bw_per_piece * newQty).toFixed(3) 
          : formData.weight_bw,
        wastage_weight: formData.tag_wastage_weight_per_piece 
          ? (formData.tag_wastage_weight_per_piece * newQty).toFixed(3) 
          : formData.wastage_weight,
        total_weight_aw: formData.tag_total_weight_aw_per_piece 
          ? (formData.tag_total_weight_aw_per_piece * newQty).toFixed(3) 
          : formData.total_weight_aw,
      };
      
      
      setFormData(updatedFormData);
      return;
    }
    
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    let updatedFormData = { ...formData, [name]: value };
    // Handle category changes
    if (name === "category") {
      // Find the first product that matches this category
      const categoryProduct = products.find(
        (prod) => prod.product_name === value
      );

      if (categoryProduct) {
        updatedFormData = {
          ...updatedFormData,
          code: categoryProduct.rbarcode || "",
          product_id: categoryProduct.product_id || "",
          metal_type: categoryProduct.Category || "",
          selling_purity: "",
          product_name: "",
          rate: "",
          // rate_24k: "",
        };
      } else {
        // If no product found, clear related fields
        updatedFormData = {
          ...updatedFormData,
          code: "",
          product_id: "",
          metal_type: "",
        };
      }
    }

    // Handle selling_purity changes
    if (name === "selling_purity") {
      if (value === "") {
        // Clear fields when "Select Purity" is chosen
        setFormData((prev) => ({
          ...prev,
          selling_purity: "",
          custom_purity: "",
          rate: "",
        }));
        return;
      } else if (value === "Manual") {
        updatedFormData.rate = "";
      } else {
        // Calculate rate for any purity value
        const purityValue = parseFloat(value);
        if (!isNaN(purityValue) && formData.rate_24k) {
          const baseRate = parseFloat(formData.rate_24k);
          updatedFormData.rate = ((purityValue / 100) * baseRate).toFixed(2);
        }
      }
    }

    if (name === "product_name") {
      if (value === "") {
        updatedFormData.selling_purity = "";
        updatedFormData.purity = "";
        updatedFormData.printing_purity = "";
        updatedFormData.pricing = "By Weight"; // Reset pricing when sub category is cleared
        updatedFormData.rate = "";
      } else {
        const selectedSubCategory = subcategoryOptions.find(
          (option) => option.value === value
        );

        if (selectedSubCategory) {
          updatedFormData.selling_purity =
            selectedSubCategory.selling_purity || "";
          updatedFormData.purity = selectedSubCategory.purity || "";
          updatedFormData.printing_purity =
            selectedSubCategory.printing_purity || "";
          updatedFormData.pricingOpt= selectedSubCategory.pricingOpt || "";
          updatedFormData.va_percent= selectedSubCategory.va_percent || "";
          updatedFormData.mc_per_gram= selectedSubCategory.mc_per_gram || "";

          // Set pricing based on sub category
          updatedFormData.pricing = selectedSubCategory.pricing || "By Weight";

          const purityValue = parseFloat(selectedSubCategory.selling_purity);
          //const baseRate = parseFloat(formData.rate_24k) || 0;
          if (!isNaN(purityValue)) {
            updatedFormData.rate = getRateByPurity(
              purityValue,
              rates,
              formData
            );
          }
        }
      }
    }

    if (name === "custom_purity" && formData.selling_purity === "Manual") {
      if (value === "") {
        // Clear rate when custom purity is cleared
        updatedFormData.rate = "";
      } else {
        const purityValue = parseFloat(value);
        if (!isNaN(purityValue)) {
          updatedFormData.rate = getRateByPurity(purityValue, rates, formData);
        }
      }
    }

    if (name === "metal_type") {
      const metal = value.toLowerCase();
      if (metal === "gold" || metal === "diamond" || metal === "other") {
        updatedFormData.mc_on = "MC %";
      } else if (metal === "silver") {
        updatedFormData.mc_on = "MC / Gram";
      }
    }

    if (name === "category" && value === "") {
      updatedFormData = {
        ...updatedFormData, // Keep other existing values
        code: "",
        product_id: "",
        metal: "",
        product_name: "",
        metal_type: "",
        design_name: "",
        purity: "",
        selling_purity: "",
        printing_purity: "",
        pricing: "By Weight",
        category: "",
        sub_category: "",
        gross_weight: "",
        stone_weight: "",
        weight_bw: "",
        stone_price: "",
        va_on: "Gross Weight",
        va_percent: "",
        wastage_weight: "",
        total_weight_av: "",
        mc_on: "MC %",
        disscount_percentage: "",
        disscount: "",
        mc_per_gram: "",
        making_charges: "",
        rate: "",
        // rate_24k: "",
        pieace_cost: "",
        mrp_price: "",
        rate_amt: "",
        tax_percent: "03% GST",
        tax_amt: "",
        hm_charges: "60.00",
        total_price: "",
        transaction_status: "Sales",
        qty: "1",
        opentag_id: "",
        product_image: null,
        imagePreview: null,
        remarks: "",
        sale_status: "Delivered",
        //estimate_status: "Not Delivered",
        piece_taxable_amt: "",
        festival_discount: "",

        custom_purity: "",
      };
    }

    if (name === "mc_on") {
      if (value !== formData.mc_on) {
        // Reset values only when changing from the tag's initial value
        if (!formData.isTagSelected) {
          updatedFormData.mc_per_gram = "0";
          updatedFormData.making_charges = "0";
        } else {
          updatedFormData.mc_per_gram = formData.mc_per_gram; // Keep previous value
          updatedFormData.making_charges = formData.making_charges; // Keep previous value
        }
      }
    }

    if (
      formData.metal_type?.toLowerCase() === "gold" &&
      (name === "mc_per_gram" || name === "rate_amt")
    ) {
      const mcPercentage =
        parseFloat(name === "mc_per_gram" ? value : formData.mc_per_gram) || 0;
      const rateAmount =
        parseFloat(name === "rate_amt" ? value : formData.rate_amt) || 0;

      const totalMC = (mcPercentage / 100) * rateAmount;
      setFormData((prevData) => ({
        ...prevData,
        making_charges: totalMC.toFixed(2),
      }));
    }

    if (name === "disscount_percentage") {
      const discountPercentage = parseFloat(value) || 0;
      const makingCharges = parseFloat(formData.making_charges) || 0;
      const discountAmount = (discountPercentage / 100) * makingCharges;

      updatedFormData.disscount = discountAmount.toFixed(2);
    }

    if (name === "pricing" && (value === "By fixed" || value === "By Running Tag")) {
      // Clear the specified fields if pricing is "By fixed"
      // updatedFormData.purity = "";
      // updatedFormData.selling_purity = "";
      // updatedFormData.printing_purity = "";
      updatedFormData.gross_weight = "";
      updatedFormData.stone_weight = "";
      updatedFormData.weight_bw = "";
      updatedFormData.stone_price = "";
      updatedFormData.va_on = "Gross Weight"; // Reset to default if needed
      updatedFormData.va_percent = "";
      updatedFormData.wastage_weight = "";
      updatedFormData.total_weight_av = "";
      updatedFormData.mc_on = "MC %"; // Reset to default if needed
      updatedFormData.mc_per_gram = "";
      updatedFormData.making_charges = "";
      updatedFormData.disscount_percentage = "";
      updatedFormData.disscount = "";
      updatedFormData.rate = "";
      updatedFormData.custom_purity = "";
    }
    setFormData(updatedFormData);
  };

  const handleProductNameChange = (productName) => {
    const productEntries = data.filter(
      (prod) => prod.sub_category === productName
    );

    if (productEntries.length > 0) {
      const uniqueMetalTypes = Array.from(
        new Set(productEntries.map((prod) => prod.metal_type))
      ).map((metalType) => ({ metal_type: metalType }));

      setFormData((prevData) => ({
        ...prevData,
        product_name: productName,
        metal_type: "",
        design_name: "",
      }));

      setFilteredMetalTypes(uniqueMetalTypes); // Update metal types based on selected product
      setFilteredDesignOptions([]); // Clear design options initially
    } else {
      // Reset fields if no matching product entries found
      setFormData((prevData) => ({
        ...prevData,
        code: "",
        product_name: "",
        metal_type: "",
        design_name: "",
        purity: "",
        selling_purity: "",
        printing_purity: "",
        pricing: "By Weight",
        category: "",
        sub_category: "",
        gross_weight: "",
        stone_weight: "",
        stone_price: "",
        weight_bw: "",
        va_on: "Gross Weight",
        va_percent: "",
        wastage_weight: "",
        total_weight_aw: "",
        mc_on: "MC %",
        mc_per_gram: "",
        making_charges: "",
        disscount_percentage: "",
        disscount: "",
        rate: "",
        // rate_24k: "",
        pieace_cost: "",
        mrp_price: "",
        rate_amt: "",
        tax_percent: "03% GST",
        tax_amt: "",
        hm_charges: "60.00",
        total_price: "",
        qty: "", // Rese
        remarks: "",
        sale_status: "Delivered",
        estimate_status: "Not Delivered",
        piece_taxable_amt: "",
        festival_discount: "",

        custom_purity: "",
      }));

      setFilteredMetalTypes(metalTypes);
      setFilteredDesignOptions(designOptions);
    }
  };

  const handleMetalTypeChange = (metalType) => {
    const productEntries = data.filter(
      (prod) =>
        prod.sub_category === formData.product_name &&
        prod.metal_type === metalType
    );

    if (productEntries.length > 0) {
      const uniqueDesignOptions = Array.from(
        new Set(productEntries.map((prod) => prod.design_master))
      ).map((designMaster) => ({ design_master: designMaster }));

      setFormData((prevData) => ({
        ...prevData,
        metal_type: metalType,
        design_name: "",
      }));

      setFilteredDesignOptions(uniqueDesignOptions); // Update design options based on metal type
    } else {
      // Reset if no matching entries found
      setFormData((prevData) => ({
        ...prevData,
        metal_type: "",
        design_name: "",
      }));

      setFilteredDesignOptions([]);
    }
  };

  const handleDesignNameChange = (designName) => {
    const productEntries = data.filter(
      (prod) =>
        prod.sub_category === formData.product_name &&
        prod.metal_type === formData.metal_type &&
        prod.design_master === designName
    );

    if (productEntries.length > 0) {
      const uniquePurityOptions = Array.from(
        new Set(productEntries.map((prod) => prod.Purity))
      ).map((Purity) => ({ Purity }));

      setFormData((prevData) => ({
        ...prevData,
        design_name: designName,
        purity: "",
        selling_purity: "",
        printing_purity: "",
        pricing: "By Weight",
      }));

      setFilteredPurityOptions(uniquePurityOptions); // Update purity options based on design
    } else {
      setFormData((prevData) => ({
        ...prevData,
        design_name: "",
        purity: "",
        selling_purity: "",
        printing_purity: "",
        pricing: "By Weight",
      }));

      setFilteredPurityOptions([]);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await fetch(`${baseURL}/get/products`);
      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }
      const result = await response.json();
      if (result && Array.isArray(result)) {
        const formattedOptions = result.map((item) => ({
          label: item.product_name, // Display name
          value: item.product_name, // Unique value
        }));
        setCategoryOptions(formattedOptions);
      } else {
        console.error("Invalid API response format", result);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  useEffect(() => {
    fetchCategory();
  }, []);

  const hasProcessedNewSubCategory = useRef(false);

  const fetchSubCategory = async () => {
    try {
      const response = await fetch(`${baseURL}/subcategory`);
      const result = await response.json();
      if (result && result.data) {
        const filteredData = formData.product_id
          ? result.data.filter(
              (item) => item.category === formData.category
            )
          : result.data;

        const formattedOptions = filteredData.map((item) => ({
          label: item.sub_category_name,
          value: item.sub_category_name,
          selling_purity: item.selling_purity,
          printing_purity: item.printing_purity,
          purity: item.purity,
          pricing: item.pricing,
          pricingOpt:item.pricingOpt,
          va_percent:item.selling_wastage_percent,
          mc_per_gram:item.selling_mc_percent,
        }));

        setSubcategoryOptions(formattedOptions);

        // Only process new subcategory once
        if (
          location.state?.newSubCategory &&
          !hasProcessedNewSubCategory.current
        ) {
          const found = formattedOptions.find(
            (opt) => opt.label === location.state.newSubCategory
          );
          if (found) {
            setFormData((prev) => {
              const updatedData = {
                ...prev,
                product_name: found.value,
                selling_purity: found.selling_purity || "",
                purity: found.purity || "",
                printing_purity: found.printing_purity || "",
                pricing: found.pricing || "",
                pricingOpt:found.pricingOpt|| "",
                va_percent:found.selling_wastage_percent|| "",
                mc_per_gram:found.selling_mc_percent|| "",
              };

              const purityValue = parseFloat(found.selling_purity);
              const baseRate = parseFloat(prev.rate_24k) || 0;
              if (!isNaN(purityValue)) {
                updatedData.rate = ((purityValue / 100) * baseRate).toFixed(2);
              }

              return updatedData;
            });

            hasProcessedNewSubCategory.current = true;
          }
        }
      }
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };
  useEffect(() => {
    fetchSubCategory();
  }, [formData.category, formData.rate_24k, rates]);

  const [allMetalTypes, setAllMetalTypes] = useState([]);

  useEffect(() => {
    const fetchMetalType = async () => {
      try {
        const response = await fetch(`${baseURL}/metaltype`);
        const data = await response.json();

        // Extract all metal types
        const allMetalTypes = Array.from(
          new Set(data.map((product) => product.metal_name))
        );

        // Store all metal types
        setAllMetalTypes(allMetalTypes);

        // Initially, show all metal types
        setMetaltypeOptions(
          allMetalTypes.map((category) => ({
            value: category,
            label: category,
          }))
        );
      } catch (error) {
        console.error("Error fetching metal types:", error);
      }
    };

    fetchMetalType();
  }, []);

  useEffect(() => {
    if (!formData.category) {
      // Show all metal types if no category is selected
      setMetaltypeOptions(
        allMetalTypes.map((category) => ({
          value: category,
          label: category,
        }))
      );
      return;
    }

    const fetchFilteredMetalTypes = async () => {
      try {
        const response = await fetch(`${baseURL}/get/products`);
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const result = await response.json();

        // Find selected category object
        const selectedProduct = result.find(
          (item) => item.product_name === formData.category
        );

        if (selectedProduct) {
          const filteredMetals = allMetalTypes.filter(
            (metal) => metal === selectedProduct.Category
          );

          const options = filteredMetals.map((category) => ({
            value: category,
            label: category,
          }));

          setMetaltypeOptions(options);

          // Auto-select the first option only when a category is selected
          if (formData.category && options.length > 0) {
            setFormData((prev) => ({ ...prev, metal_type: options[0].value }));
          }
        }
      } catch (error) {
        console.error("Error fetching filtered metal types:", error);
      }
    };

    fetchFilteredMetalTypes();
  }, [formData.category, allMetalTypes]);

  useEffect(() => {
    const fetchDesignName = async () => {
      try {
        const response = await fetch(`${baseURL}/designmaster`);
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const result = await response.json();
        if (result && Array.isArray(result)) {
          const formattedOptions = result.map((item) => ({
            label: item.design_name, // Display name
            value: item.design_name, // Unique value
          }));
          setDesignOptions(formattedOptions);
        } else {
          console.error("Invalid API response format", result);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchDesignName();
  }, []);

  useEffect(() => {
    const fetchPurity = async () => {
      try {
        const response = await fetch(`${baseURL}/purity`);
        const data = await response.json();

        let filteredData = data;

        // If metal_type is set, filter based on it; otherwise, show all
        if (formData.metal_type) {
          filteredData = data.filter(
            (product) =>
              product.metal?.toLowerCase() === formData.metal_type.toLowerCase()
          );
        }

        const purities = Array.from(
          new Set(
            filteredData.map((product) => `${product.name} | ${product.purity}`)
          )
        );

        const purityOptions = purities.map((purity) => ({
          value: purity,
          label: purity,
        }));

        setpurityOptions(purityOptions);

        // Set default purity only if metal_type is available
        if (formData.metal_type && purityOptions.length > 0) {
          const defaultPurity = purityOptions.find((option) =>
            /22/i.test(option.value)
          )?.value;

          setFormData((prevData) => ({
            ...prevData,
            // purity: defaultPurity || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchPurity();
  }, [formData.metal_type]);

  const handleBarcodeChange = async (code) => {
    try {
      if (!code) {
        // If barcode is cleared, reset all related fields and set code to ""
        setIsBarcodeSelected(false); // Reset the barcode selection flag
        setFormData((prevData) => ({
          ...prevData,
          code: "", // Reset code when barcode is cleared
          product_id: "",
          product_name: "",
          metal_type: "",
          design_name: "",
          purity: "",
          selling_purity: "",
          printing_purity: "",
          // Don't reset pricing here - keep existing value
          category: "",
          sub_category: "",
          gross_weight: "",
          stone_weight: "",
          stone_price: "",
          weight_bw: "",
          va_on: "Gross Weight",
          va_percent: "",
          wastage_weight: "",
          total_weight_aw: "",
          mc_on: "MC %",
          mc_per_gram: "",
          making_charges: "",
          disscount_percentage: "",
          disscount: "",
          rate: "",
          // rate_24k: "",
          pieace_cost: "",
          mrp_price: "",
          rate_amt: "",
          tax_percent: "03% GST",
          tax_amt: "",
          hm_charges: "60.00",
          total_price: "",
          qty: "", // Reset qty
          remarks: "",
          sale_status: "Delivered",
          estimate_status: "Not Delivered",
          piece_taxable_amt: "",
          festival_discount: "",
          custom_purity: "",
          opentag_id: "", // Clear opentag_id when barcode is cleared
        }));
        setIsQtyEditable(true); // Default to editable if barcode is cleared
        return; // Exit early
      }

      // Check for product by code
      const product = products.find(
        (prod) => String(prod.rbarcode) === String(code)
      );
      if (product) {
        setIsBarcodeSelected(true);

        // Find the default purity value that includes "22"
        const defaultPurity = purityOptions.find((option) =>
          /22/i.test(option.value)
        )?.value; // Set the barcode as selected
        const metalType = product.Category || "";
        const mcOnValue =
          metalType.toLowerCase() === "silver" ? "MC / Gram" : "MC %";
        setFormData((prevData) => ({
          ...prevData,
          code: product.rbarcode, // Retain the selected barcode
          product_id: product.product_id,
          product_name: "", // Make editable
          metal_type: product.Category,
          design_name: "", // Make editable
          // purity: defaultPurity || "",
          // Don't reset pricing here - keep existing value
          category: product.product_name,
          sub_category: "",
          gross_weight: "",
          stone_weight: "",
          stone_price: "",
          weight_bw: "",
          va_on: "Gross Weight",
          va_percent: "",
          wastage_weight: "",
          total_weight_aw: "",
          pieace_cost: "",
          mrp_price: "",
          mc_on: mcOnValue,
          mc_per_gram: "",
          making_charges: "",
          disscount_percentage: "",
          disscount: "",
          tax_percent: product.tax_slab,
          qty: 1, // Set qty to 1 for product
          festival_discount: "",
          custom_purity: "",
          tag_balance_pcs: "",
          tag_balance_weight: "",
          opentag_id: "", // Clear opentag_id when switching to normal product
        }));
        setIsQtyEditable(true); // Set qty as read-only
      } else {
        // Check if tag exists by code
        const tag = data.find(
          (tag) => String(tag.PCode_BarCode) === String(code)
        );
        if (tag) {
          // If the tag is marked as "Sold"
          if (
            tag.Status === "Sold" ||
            tag.Status === "Sale Returned" ||
            tag.Status === "Reserved"
          ) {
            alert("The product is already sold out!");
            setFormData((prevData) => ({
              ...prevData,
            }));
            setIsQtyEditable(true); // Allow editing of qty
            return;
          }

          const productId = tag.product_id;
          const productDetails = products.find(
            (prod) => String(prod.product_id) === String(productId)
          );
          
          // Fetch purchase record using tag's invoice number to get actual purchase values
          let purchaseRecord = null;
          if (tag.invoice) {
            try {
              const purchaseResponse = await axios.get(`${baseURL}/get-purchase-details/${tag.invoice}`);
              const purchaseData = purchaseResponse.data?.repeatedData || [];
              
              // Find the specific product in the purchase record that matches this tag
              purchaseRecord = purchaseData.find(
                (item) => String(item.product_id) === String(tag.product_id)
              );
            } catch (error) {
              console.error("Error fetching purchase record:", error);
            }
          }
          // Use local stock if available, otherwise use tag data
          const localStockData = localStock[String(code)] || {};
          const tagRemainingPcsRaw = localStockData.rem_pcs !== undefined && localStockData.rem_pcs !== null
            ? localStockData.rem_pcs
            : (tag.rem_pcs !== undefined && tag.rem_pcs !== null
                ? tag.rem_pcs
                : tag.pcs);
          const balancePcs =
            tagRemainingPcsRaw !== undefined && tagRemainingPcsRaw !== null
              ? tagRemainingPcsRaw
              : "";

          // Check if product is sold out (remaining pieces is 0 or less)
          const remainingPcsNum = parseFloat(balancePcs) || 0;
          if (remainingPcsNum <= 0) {
            alert("The product is already sold out!");
            setFormData((prevData) => ({
              ...prevData,
              code: "", // Clear the barcode
            }));
            setIsQtyEditable(true);
            return;
          }

          let balanceWeight = localStockData.rem_gross_weight !== undefined && localStockData.rem_gross_weight !== ""
            ? localStockData.rem_gross_weight
            : (tag.rem_gross_weight ??
               tag.balance_weight ??
               tag.remaining_weight ??
               "");

          if (
            (balanceWeight === "" ||
              balanceWeight === null ||
              balanceWeight === undefined) &&
            balancePcs !== "" &&
            balancePcs !== null
          ) {
            const totalGross =
              parseFloat(tag.Gross_Weight ?? tag.TotalWeight_AW) || 0;
            const totalPcs = parseFloat(tag.pcs) || 0;
            const remainingPcsNum = parseFloat(balancePcs);
            if (
              Number.isFinite(totalGross) &&
              Number.isFinite(totalPcs) &&
              totalPcs > 0 &&
              Number.isFinite(remainingPcsNum)
            ) {
              const perPieceGross = totalGross / totalPcs;
              balanceWeight = (perPieceGross * remainingPcsNum).toFixed(3);
            } else {
              balanceWeight = tag.Gross_Weight || "";
            }
          }

          // Calculate the rate based on purity and current rates
          
          // Fetch subcategory details to get custom_purity and selling addon values
          let subcategoryCustomPurity = "";
          let subcategoryData = null;
          try {
            const subcategoryResponse = await axios.get(`${baseURL}/get/subcategories`);
            subcategoryData = subcategoryResponse.data.find(
              (sub) => sub.sub_category_name === tag.sub_category
            );
            if (subcategoryData && subcategoryData.custom_purity) {
              subcategoryCustomPurity = subcategoryData.custom_purity;
            }
          } catch (error) {
            console.error("Error fetching subcategory details:", error);
          }

          // For "By Running Tag" pricing, calculate combined values (Purchase + Selling Addon)
          const tagPricing = tag.Pricing || formData.pricing || "By Weight";
          const parsePercent = (val) => {
            if (val === null || val === undefined || val === "") return 0;
            const s = val.toString().replace("%", "").trim();
            const n = Number(s);
            return Number.isFinite(n) ? n : 0;
          };
          
          let combinedPurity = "";
          let combinedWastage = "";
          let combinedMC = "";
          
          if (tagPricing === "By Running Tag") {
            // Get purchase values from purchase record (fetched by invoice), not tag
            // Purchase values should come from purchaseRecord, just like in TagEntry
            let purchasePurity = 0;
            if (purchaseRecord) {
              // Use purchase record values
              if (purchaseRecord.Purity && String(purchaseRecord.Purity).toLowerCase().includes("manual")) {
                purchasePurity = parsePercent(purchaseRecord.purityPercentage || "");
              } else {
                purchasePurity = parsePercent(purchaseRecord.Purity || purchaseRecord.purityPercentage || "");
              }
            } else {
              // Fallback to tag values if purchase record not found
              if (tag.pur_Purity && String(tag.pur_Purity).toLowerCase().includes("manual")) {
                purchasePurity = parsePercent(tag.pur_purityPercentage || tag.purityPercentage || "");
              } else {
                purchasePurity = parsePercent(tag.pur_Purity || tag.pur_purityPercentage || tag.purityPercentage || "");
              }
            }
            
            const purchaseWastage = purchaseRecord 
              ? parsePercent(purchaseRecord.wastage || "")
              : parsePercent(tag.pur_Wastage_Percentage || "");
            
            // Get purchase MC - only if MC On is "MC %"
            let purchaseMC = 0;
            const mcOnValue = purchaseRecord?.Making_Charges_On || tag.pur_Making_Charges_On || "";
            if (mcOnValue === "MC %") {
              purchaseMC = purchaseRecord
                ? parsePercent(purchaseRecord.Making_Charges_Value || "")
                : parsePercent(tag.pur_MC_Per_Gram || "");
            }
            
            // Get selling addon values from subcategory
            const sellingAddonPurity = parsePercent(
              subcategoryData?.selling_addon_purity || 
              tag.selling_addon_purity || 
              ""
            );
            const sellingAddonWastage = parsePercent(
              subcategoryData?.selling_addon_wastage_percent || 
              tag.selling_addon_wastage_percent || 
              ""
            );
            const sellingAddonMC = parsePercent(
              subcategoryData?.selling_addon_mc_percent || 
              tag.selling_addon_mc_percent || 
              ""
            );
            
            // Calculate combined values
            // Selling Purity = Purchase Purity + Selling Addon Purity only (MC and Wastage shown separately)
            const totalPurity = purchasePurity + sellingAddonPurity;
            const totalWastage = purchaseWastage + sellingAddonWastage;
            const totalMC = purchaseMC + sellingAddonMC;
            
            // Format for display
            combinedPurity = totalPurity > 0 ? totalPurity.toFixed(2) : "";
            combinedWastage = totalWastage > 0 ? totalWastage.toFixed(2) : "";
            combinedMC = totalMC > 0 ? totalMC.toFixed(2) : "";
          }
          
          // Get custom purity value from tag, subcategory, or other sources
          // Priority: tag.custom_purity > subcategoryCustomPurity > tag.pur_purityPercentage
          // This is needed for both rate calculation and form data
          const customPurityValue = 
            tag.custom_purity || 
            subcategoryCustomPurity ||
            tag.pur_purityPercentage || 
            tag.purityPercentage || 
            "";
          
          // Calculate the rate based on metal type
          let rateValue = "";
          const metalType = String(tag.metal_type || "").toLowerCase();
          
          // For "By Running Tag", use combined purity for rate calculation
          // Otherwise, use the selling purity from tag
          let purityForCalculation = null;
          if (tagPricing === "By Running Tag" && combinedPurity) {
            // Use combined purity (Purchase + Selling Addon) for rate calculation
            purityForCalculation = parseFloat(combinedPurity);
          } else {
            // Use selling purity for non-running tag items
            const purity = tag.Purity || tag.pur_Purity || "";
            
            // Determine which purity value to use for rate calculation
          if (purity && String(purity).toLowerCase().includes("manual")) {
            // If purity is Manual, use custom_purity value
            purityForCalculation = parseFloat(customPurityValue);
          } else {
            // Otherwise use the purity value directly
            purityForCalculation = parseFloat(purity);
            }
          }

          if (purityForCalculation && !isNaN(purityForCalculation)) {
            const baseRate =
              metalType === "silver" ? rates.silver_rate : formData.rate_24k;
            if (baseRate) {
              rateValue = (purityForCalculation * parseFloat(baseRate)) / 100;
            }
          } else if (metalType === "silver") {
            rateValue = rates.silver_rate || "";
          }

          // For "By Running Tag" pricing, calculate weight per piece
          const tagPcs = parseFloat(tag.pcs || tag.rem_pcs || 1);
          const defaultQty = 1;
          
          // Calculate weight per piece if it's "By Running Tag" and tag has multiple PCS
          let calculatedGrossWeight = tag.Gross_Weight || "";
          let calculatedStoneWeight = tag.Stones_Weight || "";
          let calculatedWeightBW = tag.Weight_BW || "";
          let calculatedWastageWeight = tag.WastageWeight || "";
          let calculatedTotalWeightAW = tag.TotalWeight_AW || "";
          
          // Store original tag data for recalculation when qty changes
          let tagGrossWeightPerPiece = null;
          let tagStoneWeightPerPiece = null;
          let tagWeightBWPerPiece = null;
          let tagWastageWeightPerPiece = null;
          let tagTotalWeightAWPerPiece = null;
          
          if (tagPricing === "By Running Tag" && tagPcs > 1) {
            tagGrossWeightPerPiece = parseFloat(tag.Gross_Weight || 0) / tagPcs;
            tagStoneWeightPerPiece = parseFloat(tag.Stones_Weight || 0) / tagPcs;
            tagWeightBWPerPiece = parseFloat(tag.Weight_BW || 0) / tagPcs;
            tagWastageWeightPerPiece = parseFloat(tag.WastageWeight || 0) / tagPcs;
            tagTotalWeightAWPerPiece = parseFloat(tag.TotalWeight_AW || 0) / tagPcs;
            
            // Multiply by qty (default 1) to get the weight for the quantity being sold
            calculatedGrossWeight = (tagGrossWeightPerPiece * defaultQty).toFixed(3);
            calculatedStoneWeight = (tagStoneWeightPerPiece * defaultQty).toFixed(3);
            calculatedWeightBW = (tagWeightBWPerPiece * defaultQty).toFixed(3);
            calculatedWastageWeight = (tagWastageWeightPerPiece * defaultQty).toFixed(3);
            calculatedTotalWeightAW = (tagTotalWeightAWPerPiece * defaultQty).toFixed(3);
            }


          // For "By Running Tag", extract purchase values from purchase record (fetched by invoice), not tag
          // Purchase values should come from the purchase record, just like in TagEntry
          let purchasePurityValue = "";
          let purchaseWastageValue = "";
          let purchaseMCValue = "";
          
          if (tagPricing === "By Running Tag") {
            // Get purchase purity from purchase record (fetched by invoice), not tag
            // Check if it's "Manual" first, then use purityPercentage
            if (purchaseRecord?.Purity && String(purchaseRecord.Purity).toLowerCase().includes("manual")) {
              purchasePurityValue = purchaseRecord?.purityPercentage || "";
            } else {
              purchasePurityValue = purchaseRecord?.Purity || purchaseRecord?.purityPercentage || "";
          }

            // Get purchase wastage from purchase record
            purchaseWastageValue = purchaseRecord?.wastage || "";
            
            // Get purchase MC from purchase record - only if MC On is "MC %"
            if (purchaseRecord?.Making_Charges_On === "MC %") {
              purchaseMCValue = purchaseRecord?.Making_Charges_Value || "";
            }
            
            // Fallback to tag values if purchase record doesn't have them
            if (!purchasePurityValue) {
              if (tag.pur_Purity && String(tag.pur_Purity).toLowerCase().includes("manual")) {
                purchasePurityValue = tag.pur_purityPercentage || tag.purityPercentage || "";
              } else {
                purchasePurityValue = tag.pur_Purity || tag.pur_purityPercentage || tag.purityPercentage || "";
              }
            }
            if (!purchaseWastageValue) {
              purchaseWastageValue = tag.pur_Wastage_Percentage || "";
            }
            if (!purchaseMCValue) {
              purchaseMCValue = tag.pur_MC_Per_Gram || "";
            }
          }

          setFormData((prevData) => ({
            ...prevData,
            code: tag.PCode_BarCode || "", // Retain the barcode
            product_id: tag.product_id || "",
            opentag_id: tag.opentag_id || "",
            product_name: tag.sub_category || "", // Make editable
            metal_type: tag.metal_type || "",
            design_name: tag.design_master || "", // Make editable
            // For "By Running Tag", use combined purity (Purchase + Selling Addon), otherwise use tag value
            purity: tagPricing === "By Running Tag" && combinedPurity 
              ? combinedPurity 
              : (tag.pur_Purity || ""),
            selling_purity: tag.Purity || "",
            printing_purity: tag.printing_purity || "",
            // Set custom_purity from tag data (for Manual purity)
            custom_purity: customPurityValue || "",
            // Use the tag's pricing if available, otherwise keep existing value
            pricing: tagPricing,
            category: tag.category || "",
            sub_category: tag.sub_category || "",
            // For "By Running Tag", set purchase values for calculation (from purchase record fetched by invoice)
            pur_purityPercentage: tagPricing === "By Running Tag" ? purchasePurityValue : (tag.pur_purityPercentage || ""),
            pur_Purity: tagPricing === "By Running Tag" ? (purchaseRecord?.Purity || tag.pur_Purity || "") : (tag.pur_Purity || ""),
            pur_Wastage_Percentage: tagPricing === "By Running Tag" ? purchaseWastageValue : (tag.pur_Wastage_Percentage || ""),
            pur_MC_Per_Gram: tagPricing === "By Running Tag" ? purchaseMCValue : (tag.pur_MC_Per_Gram || ""),
            pur_Making_Charges_On: tagPricing === "By Running Tag" ? (purchaseRecord?.Making_Charges_On || tag.pur_Making_Charges_On || tag.Making_Charges_On || "") : (tag.pur_Making_Charges_On || tag.Making_Charges_On || ""),
            // Set selling addon values from subcategory
            selling_addon_purity: tagPricing === "By Running Tag" 
              ? (subcategoryData?.selling_addon_purity || tag.selling_addon_purity || "")
              : (prevData.selling_addon_purity || ""),
            selling_addon_mc_percent: tagPricing === "By Running Tag"
              ? (subcategoryData?.selling_addon_mc_percent || tag.selling_addon_mc_percent || "")
              : (prevData.selling_addon_mc_percent || ""),
            selling_addon_wastage_percent: tagPricing === "By Running Tag"
              ? (subcategoryData?.selling_addon_wastage_percent || tag.selling_addon_wastage_percent || "")
              : (prevData.selling_addon_wastage_percent || ""),
            gross_weight: calculatedGrossWeight,
            stone_weight: calculatedStoneWeight,
            stone_price: tag.Stones_Price || "",
            weight_bw: calculatedWeightBW,
            // Transfer all wastage-related values from TagEntry
            // For "By Running Tag", use combined wastage (Purchase + Selling Addon), otherwise use tag value
            va_on: tag.Wastage_On || "Gross Weight",
            va_percent: tagPricing === "By Running Tag" && combinedWastage 
              ? combinedWastage 
              : (tag.Wastage_Percentage || ""),
            wastage_weight: calculatedWastageWeight,
            total_weight_aw: calculatedTotalWeightAW,
            pieace_cost: tag.pieace_cost || "",
            mrp_price: tag.mrp_price || "",
            // Transfer all making charges-related values from TagEntry
            // For "By Running Tag", use purchase record's MC On and combined MC (Purchase + Selling Addon)
            // MC On should come from purchase record, not tag (tag.Making_Charges_On might be "0")
            mc_on: tagPricing === "By Running Tag" 
              ? (purchaseRecord?.Making_Charges_On || tag.pur_Making_Charges_On || "MC %")
              : (tag.Making_Charges_On || tag.pur_Making_Charges_On || "MC %"),
            // For "By Running Tag", MC % should be the combined value (Purchase MC + Selling Addon MC)
            mc_per_gram: tagPricing === "By Running Tag" && combinedMC 
              ? combinedMC 
              : (tag.MC_Per_Gram || ""),
            making_charges: tag.Making_Charges || "",
            tax_percent:
              productDetails?.tax_slab || tag.tax_percent || "03% GST",
            qty: defaultQty, // Allow qty to be editable for tag
            rate: rateValue, // Add the calculated rate
            // Store original tag data for recalculation when qty changes
            tag_pcs: tagPcs > 1 ? tagPcs : null,
            tag_gross_weight_per_piece: tagGrossWeightPerPiece,
            tag_stone_weight_per_piece: tagStoneWeightPerPiece,
            tag_weight_bw_per_piece: tagWeightBWPerPiece,
            tag_wastage_weight_per_piece: tagWastageWeightPerPiece,
            tag_total_weight_aw_per_piece: tagTotalWeightAWPerPiece,
            tag_balance_pcs: balancePcs,
            tag_balance_weight: balanceWeight,
          }));
          setIsQtyEditable(false); // Allow editing of qty
        } else {
          // Reset form if no tag is found
          setFormData((prevData) => ({
            ...prevData,
            code: "", // Reset code
            product_id: "",
            product_name: "",
            metal_type: "",
            design_name: "",
            purity: "",
            // Don't reset pricing here - keep existing value
            category: "",
            sub_category: "",
            gross_weight: "",
            stone_weight: "",
            stone_price: "",
            weight_bw: "",
            va_on: "Gross Weight",
            va_percent: "",
            wastage_weight: "",
            total_weight_aw: "",
            mc_on: "MC %",
            mc_per_gram: "",
            making_charges: "",
            disscount_percentage: "",
            disscount: "",
            rate: "",
            // rate_24k: "",
            pieace_cost: "",
            mrp_price: "",
            rate_amt: "",
            tax_percent: "03% GST",
            tax_amt: "",
            hm_charges: "60.00",
            total_price: "",
            qty: "", // Reset qty
            remarks: "",
            sale_status: "Delivered",
            estimate_status: "Not Delivered",
            piece_taxable_amt: "",
            festival_discount: "",
            tag_balance_pcs: "",
            tag_balance_weight: "",
            tag_pcs: null,
            tag_gross_weight_per_piece: null,
            tag_stone_weight_per_piece: null,
            tag_weight_bw_per_piece: null,
            tag_wastage_weight_per_piece: null,
            tag_total_weight_aw_per_piece: null,
          }));
          setIsQtyEditable(true); // Default to editable
        }
      }
    } catch (error) {
      console.error("Error handling code change:", error);
    }
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setFormData((prevData) => ({
  //         ...prevData,
  //         imagePreview: reader.result, // Update image preview in formData
  //       }));
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // This function handles the file input change event for the gallery selection.

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({ ...prev, imagePreview: reader.result }));
      };
      reader.readAsDataURL(file);
      setShowOptions(false); // Hide options after selection
    }
  };

  const clearImage = () => {
    setFormData((prev) => ({ ...prev, imagePreview: null }));
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setFormData((prev) => ({ ...prev, imagePreview: imageSrc }));
      setShowWebcam(false);
      setShowOptions(false); // Hide options after capturing
    }
  };

  // Function to restore local stock when a product is deleted
  const restoreLocalStock = (barcode, qty) => {
    if (!barcode || !qty) return;
    
    const barcodeStr = String(barcode);
    setLocalStock((prev) => {
      const currentStock = prev[barcodeStr];
      if (!currentStock) {
        // If not in local stock, try to get from data
        const tag = data.find((t) => String(t.PCode_BarCode) === barcodeStr);
        if (tag) {
          const remPcs = tag.rem_pcs !== undefined && tag.rem_pcs !== null 
            ? tag.rem_pcs 
            : tag.pcs;
          const remWeight = tag.rem_gross_weight ?? tag.balance_weight ?? tag.remaining_weight ?? "";
          
          const newRemPcs = (parseFloat(remPcs) || 0) + parseFloat(qty);
          
          // Calculate new weight if we have per-piece weight
          let newRemWeight = remWeight;
          if (remWeight && remPcs) {
            const totalGross = parseFloat(tag.Gross_Weight ?? tag.TotalWeight_AW) || 0;
            const totalPcs = parseFloat(tag.pcs) || 0;
            if (totalPcs > 0) {
              const perPieceGross = totalGross / totalPcs;
              newRemWeight = (perPieceGross * newRemPcs).toFixed(3);
            } else {
              newRemWeight = "";
            }
          }
          
          const updated = {
            ...prev,
            [barcodeStr]: {
              rem_pcs: newRemPcs,
              rem_gross_weight: newRemWeight,
            },
          };
          return updated;
        }
        return prev;
      }
      
      // Restore existing local stock
      const currentRemPcs = parseFloat(currentStock.rem_pcs) || 0;
      const newRemPcs = currentRemPcs + parseFloat(qty);
      
      // Calculate new weight
      let newRemWeight = currentStock.rem_gross_weight || "";
      if (newRemWeight && currentRemPcs > 0) {
        const perPieceWeight = parseFloat(newRemWeight) / currentRemPcs;
        newRemWeight = (perPieceWeight * newRemPcs).toFixed(3);
      } else if (newRemWeight && currentRemPcs === 0) {
        // If current stock was 0, we need to get weight from tag
        const tag = data.find((t) => String(t.PCode_BarCode) === barcodeStr);
        if (tag) {
          const totalGross = parseFloat(tag.Gross_Weight ?? tag.TotalWeight_AW) || 0;
          const totalPcs = parseFloat(tag.pcs) || 0;
          if (totalPcs > 0) {
            const perPieceGross = totalGross / totalPcs;
            newRemWeight = (perPieceGross * newRemPcs).toFixed(3);
          }
        }
      }
      
      const updated = {
        ...prev,
        [barcodeStr]: {
          rem_pcs: newRemPcs,
          rem_gross_weight: newRemWeight,
        },
      };
      return updated;
    });
  };

  // Function to clear local stock
  const clearLocalStock = () => {
    setLocalStock({});
    localStorage.removeItem('localStockTracking');
  };

  // Function to update local stock when a product is added
  const updateLocalStock = (barcode, qty) => {
    if (!barcode || !qty) return;
    
    const barcodeStr = String(barcode);
    setLocalStock((prev) => {
      const currentStock = prev[barcodeStr];
      if (!currentStock) {
        // If not in local stock, try to get from data
        const tag = data.find((t) => String(t.PCode_BarCode) === barcodeStr);
        if (tag) {
          const remPcs = tag.rem_pcs !== undefined && tag.rem_pcs !== null 
            ? tag.rem_pcs 
            : tag.pcs;
          const remWeight = tag.rem_gross_weight ?? tag.balance_weight ?? tag.remaining_weight ?? "";
          
          const newRemPcs = Math.max(0, (parseFloat(remPcs) || 0) - parseFloat(qty));
          
          // Calculate new weight if we have per-piece weight
          let newRemWeight = remWeight;
          if (remWeight && remPcs) {
            const totalGross = parseFloat(tag.Gross_Weight ?? tag.TotalWeight_AW) || 0;
            const totalPcs = parseFloat(tag.pcs) || 0;
            if (totalPcs > 0) {
              const perPieceGross = totalGross / totalPcs;
              newRemWeight = (perPieceGross * newRemPcs).toFixed(3);
            } else {
              newRemWeight = "";
            }
          }
          
          const updated = {
            ...prev,
            [barcodeStr]: {
              rem_pcs: newRemPcs,
              rem_gross_weight: newRemWeight,
            },
          };
          // Don't persist to localStorage - clear on refresh
          return updated;
        }
        return prev;
      }
      
      // Update existing local stock
      const currentRemPcs = parseFloat(currentStock.rem_pcs) || 0;
      const newRemPcs = Math.max(0, currentRemPcs - parseFloat(qty));
      
      // Calculate new weight
      let newRemWeight = currentStock.rem_gross_weight || "";
      if (newRemWeight && currentRemPcs > 0) {
        const perPieceWeight = parseFloat(newRemWeight) / currentRemPcs;
        newRemWeight = (perPieceWeight * newRemPcs).toFixed(3);
      }
      
      const updated = {
        ...prev,
        [barcodeStr]: {
          rem_pcs: newRemPcs,
          rem_gross_weight: newRemWeight,
        },
      };
      // Don't persist to localStorage - clear on refresh
      return updated;
    });
  };

  return {
    formData,
    data,
    setFormData,
    products,
    isQtyEditable,
    handleChange,
    handleImageChange,
    fileInputRef,
    clearImage,
    captureImage,
    setShowWebcam,
    showWebcam,
    webcamRef,
    setShowOptions,
    showOptions,
    image,
    handleBarcodeChange,
    handleProductNameChange,
    handleMetalTypeChange,
    handleDesignNameChange,
    filteredDesignOptions,
    filteredPurityOptions,
    filteredMetalTypes,
    categoryOptions,
    subcategoryOptions,
    designOptions,
    purityOptions,
    metaltypeOptions,
    uniqueProducts,
    isBarcodeSelected,
    fetchCategory,
    fetchSubCategory,
    isManualTotalPriceChange,
    setIsManualTotalPriceChange,
    isTotalPriceCleared,
    setIsTotalPriceCleared,
    updateLocalStock,
    restoreLocalStock,
    clearLocalStock,
    localStock,
  };
};

export default useProductHandlers;
